import {
  getFormValue,
  setQuestionLabel,
  setSectionLabel,
  setSectionsVisibilities,
  clearFieldValue,
} from 'app/services/businessFunctionHelpers';
import {
  FieldsEnum,
  FormsEnum,
  LabelEnum,
  SectionsEnum,
} from 'app/shared/enums';
import { TravelQuestionEnum } from 'app/shared/enums/TravelQuestion.enum';

const formName = FormsEnum.TravelForm;

export const numberOfPersons = {
  changeNumberOfPersons(initialRun: boolean) {
    const numberOfPersons = Number(
      getFormValue(FieldsEnum.NumberOfPersons, FormsEnum.TravelForm)
    );

    setQuestionLabel({
      key: FieldsEnum.TravelAllTravelersCurrentlyInPoland,
      formName,
      label:
        numberOfPersons === 1
          ? LabelEnum.AllFromPoland
          : LabelEnum.AllFromPolandPlural,
    });

    setQuestionLabel({
      key: FieldsEnum.TravelTransportForms,
      formName,
      label:
        numberOfPersons === 1
          ? TravelQuestionEnum.TransportForms
          : TravelQuestionEnum.TransportFormsPlural,
    });

    if (numberOfPersons === 1) {
      setSectionLabel({
        key: SectionsEnum.TravelTravelers1,
        formName,
        label: LabelEnum.Traveler,
      });
    } else {
      setSectionLabel({
        key: SectionsEnum.TravelTravelers1,
        formName,
        label: LabelEnum.FirstTraveler,
      });
    }

    const sections = [];
    const maxNumberOfPersons = 10;

    for (let i = 0; i < maxNumberOfPersons; i++) {
      sections.push({
        key: `section.travelers.${i}`,
        formName,
        visible: i < numberOfPersons,
      });
    }

    setSectionsVisibilities(sections);

    if (!initialRun) {
      clearFieldValue(
        FieldsEnum.TravelCheckoutContractSigner,
        FormsEnum.TravelForm
      );
    }
  },
};
